// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Ionic CSS Variables **/
:root {
  --ion-color-primary: #E82973;
  --ion-color-primary-rgb: 232, 41, 115;
  --ion-color-primary-contrast: #ffffff;
  --ion-color-primary-contrast-rgb: 255, 255, 255;
  --ion-color-primary-shade: #cd2367;
  --ion-color-primary-tint: #F7ACC9;
  --ion-color-primary-grad: linear-gradient(102deg, rgba(232, 41, 115, 1) 0%, rgba(238, 85, 146, 1) 35%, rgba(239, 83, 145, 1) 70%);
  --ion-color-primary-grad-vertical: linear-gradient(180deg, rgba(232, 41, 115, 1) 20%, rgba(238, 85, 146, 1) 72%, rgba(239, 83, 145, 1) 100%);
  --ion-color-secondary: #343434;
  --ion-color-secondary-rgb: 52, 52, 52;
  --ion-color-secondary-contrast: #ffffff;
  --ion-color-secondary-contrast-rgb: 255, 255, 255;
  --ion-color-secondary-shade: #2e2e2e;
  --ion-color-secondary-tint: #484848;
  --ion-color-tertiary: #007AFF;
  --ion-color-tertiary-rgb: 0, 122, 255;
  --ion-color-tertiary-contrast: #ffffff;
  --ion-color-tertiary-contrast-rgb: 255, 255, 255;
  --ion-color-tertiary-shade: #006be0;
  --ion-color-tertiary-tint: #1a87ff;
  --ion-color-success: #07AE1D;
  --ion-color-success-rgb: 7, 174, 29;
  --ion-color-success-contrast: #ffffff;
  --ion-color-success-contrast-rgb: 255, 255, 255;
  --ion-color-success-shade: #06991a;
  --ion-color-success-tint: #20b634;
  --ion-color-warning: #ffc409;
  --ion-color-warning-rgb: 255, 196, 9;
  --ion-color-warning-contrast: #000000;
  --ion-color-warning-contrast-rgb: 0, 0, 0;
  --ion-color-warning-shade: #e0ac08;
  --ion-color-warning-tint: #ffca22;
  --ion-color-danger: #E92828;
  --ion-color-danger-rgb: 233, 40, 40;
  --ion-color-danger-contrast: #ffffff;
  --ion-color-danger-contrast-rgb: 255, 255, 255;
  --ion-color-danger-shade: #cd2323;
  --ion-color-danger-tint: #eb3e3e;
  --ion-color-dark: #343434;
  --ion-color-dark-rgb: 52, 52, 52;
  --ion-color-dark-contrast: #ffffff;
  --ion-color-dark-contrast-rgb: 255, 255, 255;
  --ion-color-dark-shade: #2e2e2e;
  --ion-color-dark-tint: #484848;
  --ion-color-medium: #707070;
  --ion-color-medium-rgb: 112, 112, 112;
  --ion-color-medium-contrast: #ffffff;
  --ion-color-medium-contrast-rgb: 255, 255, 255;
  --ion-color-medium-shade: #636363;
  --ion-color-medium-tint: #7e7e7e;
  --ion-color-light: #FCFCFF;
  --ion-color-light-rgb: 252, 252, 255;
  --ion-color-light-contrast: #000000;
  --ion-color-light-contrast-rgb: 0, 0, 0;
  --ion-color-light-shade: #F6F6F6;
  --ion-color-light-tint: #fcfcff;
  --ion-color-white: #fff;
  --ion-text-color-primary: 42, 42, 42;
  --ion-text-color-Secondary: #EF5492;
  --ion-font-family: "Segoe UI";
  --app-padding-from-top: 30px;
}

.ios body,
.md body {
  --ion-color-primary: #E82973;
  --ion-color-primary-rgb: 232, 41, 115;
  --ion-color-primary-contrast: #ffffff;
  --ion-color-primary-contrast-rgb: 255, 255, 255;
  --ion-color-primary-shade: #cd2367;
  --ion-color-primary-tint: #F7ACC9;
  --ion-color-primary-grad: linear-gradient(102deg, rgba(232, 41, 115, 1) 0%, rgba(238, 85, 146, 1) 35%, rgba(239, 83, 145, 1) 70%);
  --ion-color-primary-grad-vertical: linear-gradient(180deg, rgba(232, 41, 115, 1) 20%, rgba(238, 85, 146, 1) 72%, rgba(239, 83, 145, 1) 100%);
  --ion-color-secondary: #343434;
  --ion-color-secondary-rgb: 52, 52, 52;
  --ion-color-secondary-contrast: #ffffff;
  --ion-color-secondary-contrast-rgb: 255, 255, 255;
  --ion-color-secondary-shade: #2e2e2e;
  --ion-color-secondary-tint: #484848;
  --ion-color-tertiary: #5260ff;
  --ion-color-tertiary-rgb: 82, 96, 255;
  --ion-color-tertiary-contrast: #ffffff;
  --ion-color-tertiary-contrast-rgb: 255, 255, 255;
  --ion-color-tertiary-shade: #4854e0;
  --ion-color-tertiary-tint: #6370ff;
  --ion-color-success: #07AE1D;
  --ion-color-success-rgb: 7, 174, 29;
  --ion-color-success-contrast: #ffffff;
  --ion-color-success-contrast-rgb: 255, 255, 255;
  --ion-color-success-shade: #06991a;
  --ion-color-success-tint: #20b634;
  --ion-color-warning: #ffc409;
  --ion-color-warning-rgb: 255, 196, 9;
  --ion-color-warning-contrast: #000000;
  --ion-color-warning-contrast-rgb: 0, 0, 0;
  --ion-color-warning-shade: #e0ac08;
  --ion-color-warning-tint: #ffca22;
  --ion-color-danger: #E92828;
  --ion-color-danger-rgb: 233, 40, 40;
  --ion-color-danger-contrast: #ffffff;
  --ion-color-danger-contrast-rgb: 255, 255, 255;
  --ion-color-danger-shade: #cd2323;
  --ion-color-danger-tint: #eb3e3e;
  --ion-color-dark: #343434;
  --ion-color-dark-rgb: 52, 52, 52;
  --ion-color-dark-contrast: #ffffff;
  --ion-color-dark-contrast-rgb: 255, 255, 255;
  --ion-color-dark-shade: #2e2e2e;
  --ion-color-dark-tint: #484848;
  --ion-color-medium: #707070;
  --ion-color-medium-rgb: 112, 112, 112;
  --ion-color-medium-contrast: #ffffff;
  --ion-color-medium-contrast-rgb: 255, 255, 255;
  --ion-color-medium-shade: #636363;
  --ion-color-medium-tint: #7e7e7e;
  --ion-color-light: #FCFCFF;
  --ion-color-light-rgb: 252, 252, 255;
  --ion-color-light-contrast: #000000;
  --ion-color-light-contrast-rgb: 0, 0, 0;
  --ion-color-light-shade: #F6F6F6;
  --ion-color-light-tint: #fcfcff;
  --ion-color-white: #fff;
  --ion-text-color-primary: 42, 42, 42;
  --ion-text-color-Secondary: #EF5492;
  --ion-font-family: "Segoe UI";
  --ion-background-color: var(--ion-color-light);
  --ion-background-color-rgb: var(--ion-color-light-rgb);
  --ion-text-color: var(--ion-color-dark);
  --ion-text-color-rgb: var(--ion-color-dark-rgb);
  --ion-color-step-50: #0d0d0d;
  --ion-color-step-100: #1a1a1a;
  --ion-color-step-150: #262626;
  --ion-color-step-200: #333333;
  --ion-color-step-250: #404040;
  --ion-color-step-300: #4d4d4d;
  --ion-color-step-350: #595959;
  --ion-color-step-400: #666666;
  --ion-color-step-450: #737373;
  --ion-color-step-500: #808080;
  --ion-color-step-550: #8c8c8c;
  --ion-color-step-600: #999999;
  --ion-color-step-650: #a6a6a6;
  --ion-color-step-700: #b3b3b3;
  --ion-color-step-750: #bfbfbf;
  --ion-color-step-800: #cccccc;
  --ion-color-step-850: #d9d9d9;
  --ion-color-step-900: #e6e6e6;
  --ion-color-step-950: #f2f2f2;
  --ion-item-background: transparent;
  --ion-card-background: #fff;
  /* Dark mode tijdelijk uitgeschakeld t.b.v. testomgeving/datadump (zie overdrachtsdocument)
  @media (prefers-color-scheme: dark) {
      --ion-background-color: #17171A;
      --ion-background-color-rgb: 23, 23, 26;
      --ion-text-color: #F2F2F2;
      --ion-text-color-rgb: 242, 242, 242;
      color: var(--ion-text-color);
      background: var(--ion-background-color);
  }
  */
}

:root {
  --brand: #E82973;
  --bg-app: #FFFFFF;
  --surface-card: #F5F5F5;
  --border-token: #E5E5E5;
  --text-primary-token: #1A1A1A;
  --text-secondary-token: #777777;
  --text-muted-token: #999999;
}

/* Dark mode tijdelijk uitgeschakeld t.b.v. testomgeving/datadump (zie overdrachtsdocument)
@media (prefers-color-scheme: dark) {
  :root {
    --brand: #E82973;
    --bg-app: #17171A;
    --surface-card: #3F3F45;
    --border-token: #3A3A3D;
    --text-primary-token: #F2F2F2;
    --text-secondary-token: #A0A0A5;
    --text-muted-token: #6E6E73;
    --ion-background-color: #17171A;
    --ion-background-color-rgb: 23, 23, 26;
    --ion-text-color: #F2F2F2;
    --ion-text-color-rgb: 242, 242, 242;
  }
}
*/
/** Ionic CSS Variables **/
:root {
  --ion-color-primary: #E82973;
  --ion-color-primary-rgb: 232, 41, 115;
  --ion-color-primary-contrast: #ffffff;
  --ion-color-primary-contrast-rgb: 255, 255, 255;
  --ion-color-primary-shade: #cd2367;
  --ion-color-primary-tint: #F7ACC9;
  --ion-color-primary-grad: linear-gradient(102deg, rgba(232, 41, 115, 1) 0%, rgba(238, 85, 146, 1) 35%, rgba(239, 83, 145, 1) 70%);
  --ion-color-primary-grad-vertical: linear-gradient(180deg, rgba(232, 41, 115, 1) 20%, rgba(238, 85, 146, 1) 72%, rgba(239, 83, 145, 1) 100%);
  --ion-color-secondary: #343434;
  --ion-color-secondary-rgb: 52, 52, 52;
  --ion-color-secondary-contrast: #ffffff;
  --ion-color-secondary-contrast-rgb: 255, 255, 255;
  --ion-color-secondary-shade: #2e2e2e;
  --ion-color-secondary-tint: #484848;
  --ion-color-tertiary: #007AFF;
  --ion-color-tertiary-rgb: 0, 122, 255;
  --ion-color-tertiary-contrast: #ffffff;
  --ion-color-tertiary-contrast-rgb: 255, 255, 255;
  --ion-color-tertiary-shade: #006be0;
  --ion-color-tertiary-tint: #1a87ff;
  --ion-color-success: #07AE1D;
  --ion-color-success-rgb: 7, 174, 29;
  --ion-color-success-contrast: #ffffff;
  --ion-color-success-contrast-rgb: 255, 255, 255;
  --ion-color-success-shade: #06991a;
  --ion-color-success-tint: #20b634;
  --ion-color-warning: #ffc409;
  --ion-color-warning-rgb: 255, 196, 9;
  --ion-color-warning-contrast: #000000;
  --ion-color-warning-contrast-rgb: 0, 0, 0;
  --ion-color-warning-shade: #e0ac08;
  --ion-color-warning-tint: #ffca22;
  --ion-color-danger: #E92828;
  --ion-color-danger-rgb: 233, 40, 40;
  --ion-color-danger-contrast: #ffffff;
  --ion-color-danger-contrast-rgb: 255, 255, 255;
  --ion-color-danger-shade: #cd2323;
  --ion-color-danger-tint: #eb3e3e;
  --ion-color-dark: #343434;
  --ion-color-dark-rgb: 52, 52, 52;
  --ion-color-dark-contrast: #ffffff;
  --ion-color-dark-contrast-rgb: 255, 255, 255;
  --ion-color-dark-shade: #2e2e2e;
  --ion-color-dark-tint: #484848;
  --ion-color-medium: #707070;
  --ion-color-medium-rgb: 112, 112, 112;
  --ion-color-medium-contrast: #ffffff;
  --ion-color-medium-contrast-rgb: 255, 255, 255;
  --ion-color-medium-shade: #636363;
  --ion-color-medium-tint: #7e7e7e;
  --ion-color-light: #FCFCFF;
  --ion-color-light-rgb: 252, 252, 255;
  --ion-color-light-contrast: #000000;
  --ion-color-light-contrast-rgb: 0, 0, 0;
  --ion-color-light-shade: #F6F6F6;
  --ion-color-light-tint: #fcfcff;
  --ion-color-white: #fff;
  --ion-text-color-primary: 42, 42, 42;
  --ion-text-color-Secondary: #EF5492;
  --ion-font-family: "Segoe UI";
  --app-padding-from-top: 30px;
}

.ios body,
.md body {
  --ion-color-primary: #E82973;
  --ion-color-primary-rgb: 232, 41, 115;
  --ion-color-primary-contrast: #ffffff;
  --ion-color-primary-contrast-rgb: 255, 255, 255;
  --ion-color-primary-shade: #cd2367;
  --ion-color-primary-tint: #F7ACC9;
  --ion-color-primary-grad: linear-gradient(102deg, rgba(232, 41, 115, 1) 0%, rgba(238, 85, 146, 1) 35%, rgba(239, 83, 145, 1) 70%);
  --ion-color-primary-grad-vertical: linear-gradient(180deg, rgba(232, 41, 115, 1) 20%, rgba(238, 85, 146, 1) 72%, rgba(239, 83, 145, 1) 100%);
  --ion-color-secondary: #343434;
  --ion-color-secondary-rgb: 52, 52, 52;
  --ion-color-secondary-contrast: #ffffff;
  --ion-color-secondary-contrast-rgb: 255, 255, 255;
  --ion-color-secondary-shade: #2e2e2e;
  --ion-color-secondary-tint: #484848;
  --ion-color-tertiary: #5260ff;
  --ion-color-tertiary-rgb: 82, 96, 255;
  --ion-color-tertiary-contrast: #ffffff;
  --ion-color-tertiary-contrast-rgb: 255, 255, 255;
  --ion-color-tertiary-shade: #4854e0;
  --ion-color-tertiary-tint: #6370ff;
  --ion-color-success: #07AE1D;
  --ion-color-success-rgb: 7, 174, 29;
  --ion-color-success-contrast: #ffffff;
  --ion-color-success-contrast-rgb: 255, 255, 255;
  --ion-color-success-shade: #06991a;
  --ion-color-success-tint: #20b634;
  --ion-color-warning: #ffc409;
  --ion-color-warning-rgb: 255, 196, 9;
  --ion-color-warning-contrast: #000000;
  --ion-color-warning-contrast-rgb: 0, 0, 0;
  --ion-color-warning-shade: #e0ac08;
  --ion-color-warning-tint: #ffca22;
  --ion-color-danger: #E92828;
  --ion-color-danger-rgb: 233, 40, 40;
  --ion-color-danger-contrast: #ffffff;
  --ion-color-danger-contrast-rgb: 255, 255, 255;
  --ion-color-danger-shade: #cd2323;
  --ion-color-danger-tint: #eb3e3e;
  --ion-color-dark: #343434;
  --ion-color-dark-rgb: 52, 52, 52;
  --ion-color-dark-contrast: #ffffff;
  --ion-color-dark-contrast-rgb: 255, 255, 255;
  --ion-color-dark-shade: #2e2e2e;
  --ion-color-dark-tint: #484848;
  --ion-color-medium: #707070;
  --ion-color-medium-rgb: 112, 112, 112;
  --ion-color-medium-contrast: #ffffff;
  --ion-color-medium-contrast-rgb: 255, 255, 255;
  --ion-color-medium-shade: #636363;
  --ion-color-medium-tint: #7e7e7e;
  --ion-color-light: #FCFCFF;
  --ion-color-light-rgb: 252, 252, 255;
  --ion-color-light-contrast: #000000;
  --ion-color-light-contrast-rgb: 0, 0, 0;
  --ion-color-light-shade: #F6F6F6;
  --ion-color-light-tint: #fcfcff;
  --ion-color-white: #fff;
  --ion-text-color-primary: 42, 42, 42;
  --ion-text-color-Secondary: #EF5492;
  --ion-font-family: "Segoe UI";
  --ion-background-color: var(--ion-color-light);
  --ion-background-color-rgb: var(--ion-color-light-rgb);
  --ion-text-color: var(--ion-color-dark);
  --ion-text-color-rgb: var(--ion-color-dark-rgb);
  --ion-color-step-50: #0d0d0d;
  --ion-color-step-100: #1a1a1a;
  --ion-color-step-150: #262626;
  --ion-color-step-200: #333333;
  --ion-color-step-250: #404040;
  --ion-color-step-300: #4d4d4d;
  --ion-color-step-350: #595959;
  --ion-color-step-400: #666666;
  --ion-color-step-450: #737373;
  --ion-color-step-500: #808080;
  --ion-color-step-550: #8c8c8c;
  --ion-color-step-600: #999999;
  --ion-color-step-650: #a6a6a6;
  --ion-color-step-700: #b3b3b3;
  --ion-color-step-750: #bfbfbf;
  --ion-color-step-800: #cccccc;
  --ion-color-step-850: #d9d9d9;
  --ion-color-step-900: #e6e6e6;
  --ion-color-step-950: #f2f2f2;
  --ion-item-background: transparent;
  --ion-card-background: #fff;
  /* Dark mode tijdelijk uitgeschakeld t.b.v. testomgeving/datadump (zie overdrachtsdocument)
  @media (prefers-color-scheme: dark) {
      --ion-background-color: #17171A;
      --ion-background-color-rgb: 23, 23, 26;
      --ion-text-color: #F2F2F2;
      --ion-text-color-rgb: 242, 242, 242;
      color: var(--ion-text-color);
      background: var(--ion-background-color);
  }
  */
}

:root {
  --brand: #E82973;
  --bg-app: #FFFFFF;
  --surface-card: #F5F5F5;
  --border-token: #E5E5E5;
  --text-primary-token: #1A1A1A;
  --text-secondary-token: #777777;
  --text-muted-token: #999999;
}

/* Dark mode tijdelijk uitgeschakeld t.b.v. testomgeving/datadump (zie overdrachtsdocument)
@media (prefers-color-scheme: dark) {
  :root {
    --brand: #E82973;
    --bg-app: #17171A;
    --surface-card: #3F3F45;
    --border-token: #3A3A3D;
    --text-primary-token: #F2F2F2;
    --text-secondary-token: #A0A0A5;
    --text-muted-token: #6E6E73;
    --ion-background-color: #17171A;
    --ion-background-color-rgb: 23, 23, 26;
    --ion-text-color: #F2F2F2;
    --ion-text-color-rgb: 242, 242, 242;
  }
}
*/
:host ion-header {
  position: relative;
  top: 0px;
  left: 0;
  right: 0;
  width: 100%;
  --box-shadow: none;
  box-shadow: none;
  background: transparent;
  padding-top: 12px;
  padding-bottom: 12px;
  --background: transparent;
}
:host ion-header:after {
  display: none;
}
:host ion-header ion-toolbar {
  --background: transparent;
  --border-width: 0px;
  color: var(--ion-color-secondary);
  --min-height: 40px;
  --padding-bottom: 5px;
  --padding-top: 5px;
  --padding-start: 20px;
  --padding-end: 15px;
  --box-shadow: none;
  position: relative;
}
:host ion-header ion-toolbar ion-buttons {
  margin: 0;
}
:host ion-header ion-toolbar ion-buttons ion-button {
  margin: 0;
  --background: transparent;
  box-shadow: none;
  --background-focused: transparent;
  --background-focused-opacity: 0;
  --background-hover: transparent;
  --background-hover-opacity: 0;
  --background-activated: transparent;
  --background-activated-opacity: 0;
  --border-radius: 0;
  border-radius: 0;
  --color: var(--ion-color-secondary);
  --padding-end: 0;
  --padding-top: 3px;
  --padding-bottom: 3px;
  --padding-start: 0;
  font-size: 24px;
}
:host ion-header ion-toolbar ion-buttons ion-button .menu-btn {
  position: relative;
}
:host ion-header ion-toolbar ion-buttons ion-back-button {
  --color: rgba(var(--ion-color-secondary-rgb), 0.9);
}
:host ion-header ion-toolbar ion-title {
  text-align: center;
  font-size: 1.3333333333rem;
  font-weight: 600;
  position: absolute;
  left: 50%;
  padding: 0;
  top: 50%;
  transform: translate(-50%, -50%);
  max-width: 200px;
  line-height: 1.5;
}
:host ion-header ion-toolbar ion-title.logo {
  position: absolute;
  left: 50%;
  right: 0;
  top: 50%;
  padding: 0;
  transform: translate(-50%, -50%);
}
:host ion-header ion-toolbar ion-title.logo img {
  max-width: 7.2777777778rem;
  height: auto;
  display: inline-block;
}
:host ion-header.greyHeader {
  background: var(--ion-color-light-shade);
  --background: var(--ion-color-light-shade);
}
:host ion-content {
  --padding-top: 0;
  --offset-bottom: -100px;
}

:host ion-content ion-grid {
  padding: 0;
}
:host ion-content ion-grid ion-col {
  padding: 0;
}
:host ion-content p {
  padding: 20px;
  margin: 0px;
  text-align: left;
  font-size: 1.1111111111rem;
  color: rbga(var(--ion-color-secondary-rbg), 0.7);
  opacity: 70%;
  letter-spacing: 0;
}`, "",{"version":3,"sources":["webpack://./src/theme/variables.scss","webpack://./src/app/pages/about/about.page.scss","webpack://./src/assets/CustomCss/custom-header.scss"],"names":[],"mappings":"AAGA,0BAAA;AAEA;EACI,4BAAA;EACA,qCAAA;EACA,qCAAA;EACA,+CAAA;EACA,kCAAA;EACA,iCAAA;EACA,iIAAA;EACA,4IAAA;EAEA,8BAAA;EACA,qCAAA;EACA,uCAAA;EACA,iDAAA;EACA,oCAAA;EACA,mCAAA;EAEA,6BAAA;EACA,qCAAA;EACA,sCAAA;EACA,gDAAA;EACA,mCAAA;EACA,kCAAA;EAEA,4BAAA;EACA,mCAAA;EACA,qCAAA;EACA,+CAAA;EACA,kCAAA;EACA,iCAAA;EAEA,4BAAA;EACA,oCAAA;EACA,qCAAA;EACA,yCAAA;EACA,kCAAA;EACA,iCAAA;EAEA,2BAAA;EACA,mCAAA;EACA,oCAAA;EACA,8CAAA;EACA,iCAAA;EACA,gCAAA;EAEA,yBAAA;EACA,gCAAA;EACA,kCAAA;EACA,4CAAA;EACA,+BAAA;EACA,8BAAA;EAEA,2BAAA;EACA,qCAAA;EACA,oCAAA;EACA,8CAAA;EACA,iCAAA;EACA,gCAAA;EAEA,0BAAA;EACA,oCAAA;EACA,mCAAA;EACA,uCAAA;EACA,gCAAA;EACA,+BAAA;EAEA,uBAAA;EACA,oCAAA;EACA,mCAAA;EAEA,6BAAA;EAEA,4BAAA;ACdJ;;ADiBA;;EAEI,4BAAA;EACA,qCAAA;EACA,qCAAA;EACA,+CAAA;EACA,kCAAA;EACA,iCAAA;EACA,iIAAA;EACA,4IAAA;EAEA,8BAAA;EACA,qCAAA;EACA,uCAAA;EACA,iDAAA;EACA,oCAAA;EACA,mCAAA;EAEA,6BAAA;EACA,qCAAA;EACA,sCAAA;EACA,gDAAA;EACA,mCAAA;EACA,kCAAA;EAEA,4BAAA;EACA,mCAAA;EACA,qCAAA;EACA,+CAAA;EACA,kCAAA;EACA,iCAAA;EAEA,4BAAA;EACA,oCAAA;EACA,qCAAA;EACA,yCAAA;EACA,kCAAA;EACA,iCAAA;EAEA,2BAAA;EACA,mCAAA;EACA,oCAAA;EACA,8CAAA;EACA,iCAAA;EACA,gCAAA;EAEA,yBAAA;EACA,gCAAA;EACA,kCAAA;EACA,4CAAA;EACA,+BAAA;EACA,8BAAA;EAEA,2BAAA;EACA,qCAAA;EACA,oCAAA;EACA,8CAAA;EACA,iCAAA;EACA,gCAAA;EAEA,0BAAA;EACA,oCAAA;EACA,mCAAA;EACA,uCAAA;EACA,gCAAA;EACA,+BAAA;EAEA,uBAAA;EACA,oCAAA;EACA,mCAAA;EAEA,6BAAA;EAIA,8CAAA;EACA,sDAAA;EACA,uCAAA;EACA,+CAAA;EACA,4BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,kCAAA;EACA,2BAAA;EACA;;;;;;;;;GAAA;AClBJ;;AD+BA;EACE,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,uBAAA;EACA,6BAAA;EACA,+BAAA;EACA,2BAAA;AC5BF;;AD+BA;;;;;;;;;;;;;;;;CAAA;AAxMA,0BAAA;AAEA;EACI,4BAAA;EACA,qCAAA;EACA,qCAAA;EACA,+CAAA;EACA,kCAAA;EACA,iCAAA;EACA,iIAAA;EACA,4IAAA;EAEA,8BAAA;EACA,qCAAA;EACA,uCAAA;EACA,iDAAA;EACA,oCAAA;EACA,mCAAA;EAEA,6BAAA;EACA,qCAAA;EACA,sCAAA;EACA,gDAAA;EACA,mCAAA;EACA,kCAAA;EAEA,4BAAA;EACA,mCAAA;EACA,qCAAA;EACA,+CAAA;EACA,kCAAA;EACA,iCAAA;EAEA,4BAAA;EACA,oCAAA;EACA,qCAAA;EACA,yCAAA;EACA,kCAAA;EACA,iCAAA;EAEA,2BAAA;EACA,mCAAA;EACA,oCAAA;EACA,8CAAA;EACA,iCAAA;EACA,gCAAA;EAEA,yBAAA;EACA,gCAAA;EACA,kCAAA;EACA,4CAAA;EACA,+BAAA;EACA,8BAAA;EAEA,2BAAA;EACA,qCAAA;EACA,oCAAA;EACA,8CAAA;EACA,iCAAA;EACA,gCAAA;EAEA,0BAAA;EACA,oCAAA;EACA,mCAAA;EACA,uCAAA;EACA,gCAAA;EACA,+BAAA;EAEA,uBAAA;EACA,oCAAA;EACA,mCAAA;EAEA,6BAAA;EAEA,4BAAA;ACiLJ;;AD9KA;;EAEI,4BAAA;EACA,qCAAA;EACA,qCAAA;EACA,+CAAA;EACA,kCAAA;EACA,iCAAA;EACA,iIAAA;EACA,4IAAA;EAEA,8BAAA;EACA,qCAAA;EACA,uCAAA;EACA,iDAAA;EACA,oCAAA;EACA,mCAAA;EAEA,6BAAA;EACA,qCAAA;EACA,sCAAA;EACA,gDAAA;EACA,mCAAA;EACA,kCAAA;EAEA,4BAAA;EACA,mCAAA;EACA,qCAAA;EACA,+CAAA;EACA,kCAAA;EACA,iCAAA;EAEA,4BAAA;EACA,oCAAA;EACA,qCAAA;EACA,yCAAA;EACA,kCAAA;EACA,iCAAA;EAEA,2BAAA;EACA,mCAAA;EACA,oCAAA;EACA,8CAAA;EACA,iCAAA;EACA,gCAAA;EAEA,yBAAA;EACA,gCAAA;EACA,kCAAA;EACA,4CAAA;EACA,+BAAA;EACA,8BAAA;EAEA,2BAAA;EACA,qCAAA;EACA,oCAAA;EACA,8CAAA;EACA,iCAAA;EACA,gCAAA;EAEA,0BAAA;EACA,oCAAA;EACA,mCAAA;EACA,uCAAA;EACA,gCAAA;EACA,+BAAA;EAEA,uBAAA;EACA,oCAAA;EACA,mCAAA;EAEA,6BAAA;EAIA,8CAAA;EACA,sDAAA;EACA,uCAAA;EACA,+CAAA;EACA,4BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,kCAAA;EACA,2BAAA;EACA;;;;;;;;;GAAA;AC6KJ;;ADhKA;EACE,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,uBAAA;EACA,6BAAA;EACA,+BAAA;EACA,2BAAA;ACmKF;;ADhKA;;;;;;;;;;;;;;;;CAAA;AExME;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;AD4XJ;AC3XI;EACE,aAAA;AD6XN;AC3XI;EACE,yBAAA;EACA,mBAAA;EACA,iCAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AD6XN;AC5XM;EACE,SAAA;AD8XR;AC7XQ;EACE,SAAA;EACA,yBAAA;EACA,gBAAA;EACA,iCAAA;EACA,+BAAA;EACA,+BAAA;EACA,6BAAA;EACA,mCAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mCAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;AD+XV;AC1XU;EACE,kBAAA;AD4XZ;ACzXQ;EACE,kDAAA;AD2XV;ACxXM;EACE,kBAAA;EACA,0BAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,QAAA;EACA,gCAAA;EACA,gBAAA;EACA,gBAAA;AD0XR;ACzXQ;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;EACA,gCAAA;AD2XV;AC1XU;EACE,0BAAA;EACA,YAAA;EACA,qBAAA;AD4XZ;ACvXI;EACE,wCAAA;EACA,0CAAA;ADyXN;ACxRE;EACE,gBAAA;EACA,uBAAA;AD0RJ;;AAjdQ;EACI,UAAA;AAodZ;AAndY;EACI,UAAA;AAqdhB;AAldQ;EACI,aAAA;EACA,WAAA;EACA,gBAAA;EACA,0BAAA;EACA,gDAAA;EACA,YAAA;EACA,iBAAA;AAodZ","sourcesContent":["// Ionic Variables and Theming. For more info, please see:\n// http://ionicframework.com/docs/theming/\n\n/** Ionic CSS Variables **/\n\n:root {\n    --ion-color-primary: #E82973;\n    --ion-color-primary-rgb: 232, 41, 115;\n    --ion-color-primary-contrast: #ffffff;\n    --ion-color-primary-contrast-rgb: 255, 255, 255;\n    --ion-color-primary-shade: #cd2367;\n    --ion-color-primary-tint: #F7ACC9;\n    --ion-color-primary-grad: linear-gradient(102deg, rgba(232, 41, 115, 1) 0%, rgba(238, 85, 146, 1) 35%, rgba(239, 83, 145, 1) 70%);\n    --ion-color-primary-grad-vertical: linear-gradient(180deg, rgba(232, 41, 115, 1) 20%, rgba(238, 85, 146, 1) 72%, rgba(239, 83, 145, 1) 100%);\n    ///\n    --ion-color-secondary: #343434;\n    --ion-color-secondary-rgb: 52, 52, 52;\n    --ion-color-secondary-contrast: #ffffff;\n    --ion-color-secondary-contrast-rgb: 255, 255, 255;\n    --ion-color-secondary-shade: #2e2e2e;\n    --ion-color-secondary-tint: #484848;\n    ///\n    --ion-color-tertiary: #007AFF;\n    --ion-color-tertiary-rgb: 0, 122, 255;\n    --ion-color-tertiary-contrast: #ffffff;\n    --ion-color-tertiary-contrast-rgb: 255, 255, 255;\n    --ion-color-tertiary-shade: #006be0;\n    --ion-color-tertiary-tint: #1a87ff;\n    ///\n    --ion-color-success: #07AE1D;\n    --ion-color-success-rgb: 7, 174, 29;\n    --ion-color-success-contrast: #ffffff;\n    --ion-color-success-contrast-rgb: 255, 255, 255;\n    --ion-color-success-shade: #06991a;\n    --ion-color-success-tint: #20b634;\n    ///\n    --ion-color-warning: #ffc409;\n    --ion-color-warning-rgb: 255, 196, 9;\n    --ion-color-warning-contrast: #000000;\n    --ion-color-warning-contrast-rgb: 0, 0, 0;\n    --ion-color-warning-shade: #e0ac08;\n    --ion-color-warning-tint: #ffca22;\n    //\n    --ion-color-danger: #E92828;\n    --ion-color-danger-rgb: 233, 40, 40;\n    --ion-color-danger-contrast: #ffffff;\n    --ion-color-danger-contrast-rgb: 255, 255, 255;\n    --ion-color-danger-shade: #cd2323;\n    --ion-color-danger-tint: #eb3e3e;\n    ///\n    --ion-color-dark: #343434;\n    --ion-color-dark-rgb: 52, 52, 52;\n    --ion-color-dark-contrast: #ffffff;\n    --ion-color-dark-contrast-rgb: 255, 255, 255;\n    --ion-color-dark-shade: #2e2e2e;\n    --ion-color-dark-tint: #484848;\n    ///\n    --ion-color-medium: #707070;\n    --ion-color-medium-rgb: 112, 112, 112;\n    --ion-color-medium-contrast: #ffffff;\n    --ion-color-medium-contrast-rgb: 255, 255, 255;\n    --ion-color-medium-shade: #636363;\n    --ion-color-medium-tint: #7e7e7e;\n    ///\n    --ion-color-light: #FCFCFF;\n    --ion-color-light-rgb: 252, 252, 255;\n    --ion-color-light-contrast: #000000;\n    --ion-color-light-contrast-rgb: 0, 0, 0;\n    --ion-color-light-shade: #F6F6F6;\n    --ion-color-light-tint: #fcfcff;\n    //__________________//\n    --ion-color-white: #fff;\n    --ion-text-color-primary: 42, 42, 42;\n    --ion-text-color-Secondary: #EF5492;\n    // Font Family\n    --ion-font-family: 'Segoe UI';\n    // Spacing\n    --app-padding-from-top: 30px;\n}\n\n.ios body,\n.md body {\n    --ion-color-primary: #E82973;\n    --ion-color-primary-rgb: 232, 41, 115;\n    --ion-color-primary-contrast: #ffffff;\n    --ion-color-primary-contrast-rgb: 255, 255, 255;\n    --ion-color-primary-shade: #cd2367;\n    --ion-color-primary-tint: #F7ACC9;\n    --ion-color-primary-grad: linear-gradient(102deg, rgba(232, 41, 115, 1) 0%, rgba(238, 85, 146, 1) 35%, rgba(239, 83, 145, 1) 70%);\n    --ion-color-primary-grad-vertical: linear-gradient(180deg, rgba(232, 41, 115, 1) 20%, rgba(238, 85, 146, 1) 72%, rgba(239, 83, 145, 1) 100%);\n    ///\n    --ion-color-secondary: #343434;\n    --ion-color-secondary-rgb: 52, 52, 52;\n    --ion-color-secondary-contrast: #ffffff;\n    --ion-color-secondary-contrast-rgb: 255, 255, 255;\n    --ion-color-secondary-shade: #2e2e2e;\n    --ion-color-secondary-tint: #484848;\n    ///\n    --ion-color-tertiary: #5260ff;\n    --ion-color-tertiary-rgb: 82, 96, 255;\n    --ion-color-tertiary-contrast: #ffffff;\n    --ion-color-tertiary-contrast-rgb: 255, 255, 255;\n    --ion-color-tertiary-shade: #4854e0;\n    --ion-color-tertiary-tint: #6370ff;\n    ///\n    --ion-color-success: #07AE1D;\n    --ion-color-success-rgb: 7, 174, 29;\n    --ion-color-success-contrast: #ffffff;\n    --ion-color-success-contrast-rgb: 255, 255, 255;\n    --ion-color-success-shade: #06991a;\n    --ion-color-success-tint: #20b634;\n    ///\n    --ion-color-warning: #ffc409;\n    --ion-color-warning-rgb: 255, 196, 9;\n    --ion-color-warning-contrast: #000000;\n    --ion-color-warning-contrast-rgb: 0, 0, 0;\n    --ion-color-warning-shade: #e0ac08;\n    --ion-color-warning-tint: #ffca22;\n    //\n    --ion-color-danger: #E92828;\n    --ion-color-danger-rgb: 233, 40, 40;\n    --ion-color-danger-contrast: #ffffff;\n    --ion-color-danger-contrast-rgb: 255, 255, 255;\n    --ion-color-danger-shade: #cd2323;\n    --ion-color-danger-tint: #eb3e3e;\n    ///\n    --ion-color-dark: #343434;\n    --ion-color-dark-rgb: 52, 52, 52;\n    --ion-color-dark-contrast: #ffffff;\n    --ion-color-dark-contrast-rgb: 255, 255, 255;\n    --ion-color-dark-shade: #2e2e2e;\n    --ion-color-dark-tint: #484848;\n    ///\n    --ion-color-medium: #707070;\n    --ion-color-medium-rgb: 112, 112, 112;\n    --ion-color-medium-contrast: #ffffff;\n    --ion-color-medium-contrast-rgb: 255, 255, 255;\n    --ion-color-medium-shade: #636363;\n    --ion-color-medium-tint: #7e7e7e;\n    ///\n    --ion-color-light: #FCFCFF;\n    --ion-color-light-rgb: 252, 252, 255;\n    --ion-color-light-contrast: #000000;\n    --ion-color-light-contrast-rgb: 0, 0, 0;\n    --ion-color-light-shade: #F6F6F6;\n    --ion-color-light-tint: #fcfcff;\n    ////////////\n    --ion-color-white: #fff;\n    --ion-text-color-primary: 42, 42, 42;\n    --ion-text-color-Secondary: #EF5492;\n    // Font Family\n    --ion-font-family: 'Segoe UI';\n    //////////\n    //////////\n    // ////////\n    --ion-background-color: var(--ion-color-light);\n    --ion-background-color-rgb: var(--ion-color-light-rgb);\n    --ion-text-color: var(--ion-color-dark);\n    --ion-text-color-rgb: var(--ion-color-dark-rgb);\n    --ion-color-step-50: #0d0d0d;\n    --ion-color-step-100: #1a1a1a;\n    --ion-color-step-150: #262626;\n    --ion-color-step-200: #333333;\n    --ion-color-step-250: #404040;\n    --ion-color-step-300: #4d4d4d;\n    --ion-color-step-350: #595959;\n    --ion-color-step-400: #666666;\n    --ion-color-step-450: #737373;\n    --ion-color-step-500: #808080;\n    --ion-color-step-550: #8c8c8c;\n    --ion-color-step-600: #999999;\n    --ion-color-step-650: #a6a6a6;\n    --ion-color-step-700: #b3b3b3;\n    --ion-color-step-750: #bfbfbf;\n    --ion-color-step-800: #cccccc;\n    --ion-color-step-850: #d9d9d9;\n    --ion-color-step-900: #e6e6e6;\n    --ion-color-step-950: #f2f2f2;\n    --ion-item-background: transparent;\n    --ion-card-background: #fff;\n    /* Dark mode tijdelijk uitgeschakeld t.b.v. testomgeving/datadump (zie overdrachtsdocument)\n    @media (prefers-color-scheme: dark) {\n        --ion-background-color: #17171A;\n        --ion-background-color-rgb: 23, 23, 26;\n        --ion-text-color: #F2F2F2;\n        --ion-text-color-rgb: 242, 242, 242;\n        color: var(--ion-text-color);\n        background: var(--ion-background-color);\n    }\n    */\n}\n\n// --- Stijlgids-tokens (modernisatietraject, licht/donker via prefers-color-scheme) ---\n:root {\n  --brand: #E82973;\n  --bg-app: #FFFFFF;\n  --surface-card: #F5F5F5;\n  --border-token: #E5E5E5;\n  --text-primary-token: #1A1A1A;\n  --text-secondary-token: #777777;\n  --text-muted-token: #999999;\n}\n\n/* Dark mode tijdelijk uitgeschakeld t.b.v. testomgeving/datadump (zie overdrachtsdocument)\n@media (prefers-color-scheme: dark) {\n  :root {\n    --brand: #E82973;\n    --bg-app: #17171A;\n    --surface-card: #3F3F45;\n    --border-token: #3A3A3D;\n    --text-primary-token: #F2F2F2;\n    --text-secondary-token: #A0A0A5;\n    --text-muted-token: #6E6E73;\n    --ion-background-color: #17171A;\n    --ion-background-color-rgb: 23, 23, 26;\n    --ion-text-color: #F2F2F2;\n    --ion-text-color-rgb: 242, 242, 242;\n  }\n}\n*/\n","@use \"../../../theme/mixins.scss\"as *;\n@import \"../../../theme/variables.scss\";\n@import \"../../../assets/CustomCss/custom-header.scss\";\n:host {\n    ion-content {\n        ion-grid {\n            padding: 0;\n            ion-col {\n                padding: 0;\n            }\n        }\n        p {\n            padding: 20px;\n            margin: 0px;\n            text-align: left;\n            font-size: calculateRem(20px);\n            color: rbga(var(--ion-color-secondary-rbg), 0.7);\n            opacity: 70%;\n            letter-spacing: 0;\n        }\n    }\n}","@import \"../../theme/variables.scss\";\n@import \"../../theme/mixins.scss\";\n:host {\n  ion-header {\n    position: relative;\n    top: 0px;\n    left: 0;\n    right: 0;\n    width: 100%;\n    --box-shadow: none;\n    box-shadow: none;\n    background: transparent;\n    padding-top: 12px;\n    padding-bottom: 12px;\n    --background: transparent;\n    &:after {\n      display: none;\n    }\n    ion-toolbar {\n      --background: transparent;\n      --border-width: 0px;\n      color: var(--ion-color-secondary);\n      --min-height: 40px;\n      --padding-bottom: 5px;\n      --padding-top: 5px;\n      --padding-start: 20px;\n      --padding-end: 15px;\n      --box-shadow: none;\n      position: relative;\n      ion-buttons {\n        margin: 0;\n        ion-button {\n          margin: 0;\n          --background: transparent;\n          box-shadow: none;\n          --background-focused: transparent;\n          --background-focused-opacity: 0;\n          --background-hover: transparent;\n          --background-hover-opacity: 0;\n          --background-activated: transparent;\n          --background-activated-opacity: 0;\n          --border-radius: 0;\n          border-radius: 0;\n          --color: var(--ion-color-secondary);\n          --padding-end: 0;\n          --padding-top: 3px;\n          --padding-bottom: 3px;\n          --padding-start: 0;\n          font-size: 24px;\n          // padding: 0;\n          // &::part(native) {\n          //     padding: 0;\n          // }\n          .menu-btn {\n            position: relative;\n          }\n        }\n        ion-back-button {\n          --color: rgba(var(--ion-color-secondary-rgb), 0.9);\n        }\n      }\n      ion-title {\n        text-align: center;\n        font-size: calculateRem(24px);\n        font-weight: 600;\n        position: absolute;\n        left: 50%;\n        padding: 0;\n        top: 50%;\n        transform: translate(-50%, -50%);\n        max-width: 200px;\n        line-height: 1.5;\n        &.logo {\n          position: absolute;\n          left: 50%;\n          right: 0;\n          top: 50%;\n          padding: 0;\n          transform: translate(-50%, -50%);\n          img {\n            max-width: calculateRem(131px);\n            height: auto;\n            display: inline-block;\n          }\n        }\n      }\n    }\n    &.greyHeader {\n      background: var(--ion-color-light-shade);\n      --background: var(--ion-color-light-shade);\n    }\n    // &.curved-header {\n    //     position: relative;\n    //     padding-top: 0px;\n    //     padding-bottom: 0px;\n    //     height: 75px;\n    //     display: flex;\n    //     align-items: center;\n    //     justify-content: stretch;\n    //     &:after {\n    //         background: var(--ion-color-primary-tint);\n    //         left: 25px;\n    //         right: 25px;\n    //         bottom: 0;\n    //         height: 15px;\n    //         border-radius: 24px 24px 0 0;\n    //         position: absolute;\n    //         width: auto;\n    //     }\n    //     ion-toolbar {\n    //         position: relative;\n    //         --min-height: 50px;\n    //         --background: transparent;\n    //         --border-width: 0px;\n    //         color: var(--ion-color-white);\n    //         --padding-top: 0;\n    //         --padding-bottom: 0px;\n    //         --padding-start: 18px;\n    //         --padding-end: 18px;\n    //         --box-shadow: none;\n    //         ion-buttons {\n    //             margin: 0px;\n    //             .menu-btn {}\n    //             ion-back-button {\n    //                 --border-radius: 4px;\n    //                 --background: rgba(255, 255, 255, 0.678);\n    //                 --min-height: 43px;\n    //                 --min-width: 45px;\n    //                 --border-radius: 14px;\n    //                 color: var(--ion-color-secondary);\n    //                 --icon-font-weight: 300;\n    //             }\n    //             ion-menu-button,\n    //             ion-button {\n    //                 --background: transparent;\n    //                 box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.05);\n    //                 --background-focused: #fff;\n    //                 --background-focused-opacity: 1;\n    //                 --background-hover: #fff;\n    //                 --background-hover-opacity: 1;\n    //                 --border-radius: 14px;\n    //                 border-radius: 14px;\n    //                 color: var(--ion-color-white);\n    //                 --padding-bottom: 0;\n    //                 --padding-top: 0;\n    //                 --padding-bottom: 0;\n    //                 --padding-bottom: 0;\n    //                 width: 45px;\n    //                 height: 43px;\n    //                 span {\n    //                     color: var(--ion-color-white);\n    //                 }\n    //                 &.bg-white {\n    //                     --border-radius: 4px;\n    //                     --background: rgba(255, 255, 255, 0.678);\n    //                     --min-height: 43px;\n    //                     --min-width: 45px;\n    //                     --border-radius: 14px;\n    //                     color: var(--ion-color-secondary);\n    //                     --icon-font-weight: 300;\n    //                 }\n    //             }\n    //         }\n    //         ion-title {\n    //             text-align: center;\n    //             color: var(--ion-color-white);\n    //             font-size: calculateRem(20px);\n    //             position: absolute;\n    //             left: 50%;\n    //             padding: 0;\n    //             top: 50%;\n    //             transform: translate(-50%, -50%);\n    //             max-width: 200px;\n    //             line-height: 1.5;\n    //         }\n    //         ion-avatar {\n    //             width: 45px;\n    //             height: 45px;\n    //             img {\n    //                 height: auto;\n    //                 max-width: 100%;\n    //             }\n    //         }\n    //     }\n    // }\n  }\n  ion-content {\n    --padding-top: 0;\n    --offset-bottom: -100px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
